/**
 * Events - Single (detail view)
 */

'use strict';

require('../misc/socialSharePopup');

// Constructor
var FrontEventsSingle = function () {
    if (!$('body').hasClass('single-cm-events')) {
        return;
    }

    $(document).ready((function() {
        this.asideMobile();
        this.setBackgroundColor();
        this.computeUiElementsPosition();
        this.computeUiTitlesSeparator();
        this.showMoreShows();
        this.placeSelector();
        this.stickyAside();
    }).bind(this));

    this.initMasonryGallery();
};

FrontEventsSingle.prototype = {
    setBackgroundColor: function() {
        var color = $('article#event').data('background-color');

        if (color.length == 7) {
            // Wrapper
            if ($(window).width() > 992) {
                $('#wrapper').css('background-color', color);
            }

            // Category badge
            $('article#event .top .badge').css('color', color);
        }
    },

    /**
     * Compute the position and place the elements on the page.
     */
    computeUiElementsPosition: function() {
        // Equal columns heights for entry-content and sidebar
        if ($(window).width() > 992) {
            $('article#event .wrapper > .col').matchHeight();
        }

        // Equal columns heights for casting items
        $('article#event #casting .item').matchHeight();

        // Selector
        $('article#event #place-selector').formSelect();
    },

    /**
     * Compute the position of the horizontal title's separator.
     */
    computeUiTitlesSeparator: function() {
        var compute = function(element) {
            var containerWidth = $(element).width();
            var labelWidth = $('span', element).outerWidth(true);
            var separatorWidth = containerWidth - labelWidth;

            if (separatorWidth > 0) {
                $('hr', element).css({
                    'width': separatorWidth + 'px',
                    'opacity': 1,
                });
            }
        };

        $('article#event .col-content .title-section').each(function() {
            compute(this);
        });

        $('article#event .col-right .widget .title').each(function() {
            compute(this);
        });
    },

    /**
     * Initialize the masonry images gallery.
     */
    initMasonryGallery: function() {
        var $grid = $('article#event #gallery .masonry').imagesLoaded(function () {
            // Init Masonry after all images have loaded
            $grid.masonry({
                itemSelector: '.gallery-item',
                columnWidth: '.gallery-item',
                percentPosition: true,
            });
        });

        $('article#event #gallery .masonry').magnificPopup({
            delegate: '.gallery-item a',
            type: 'image',
            closeOnContentClick: false,
            closeBtnInside: false,
            mainClass: 'mfp-with-zoom mfp-img-mobile',
            image: {
                titleSrc: function(item) {
                    return item.el.find('img').attr('alt');
                }
            },
            gallery: {
                enabled: true,
                preload: [0,2],
                navigateByImgClick: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                tPrev: comedien.i18n.galleryButtonPrev, // title for left button
                tNext: comedien.i18n.galleryButtonNext, // title for right button
                tCounter: '<span class="mfp-counter">%curr% '+ comedien.i18n.galleryCounter +' %total%</span>'
            },
            zoom: {
                enabled: true,
                duration: 300, // NB: also change the duration in CSS!
                opener: function(element) {
                    return element.find('img');
                }
            }
        });
    },

    /**
     * Show more shows (dates of the tour) on button click.
     */
    showMoreShows: function() {
        var btnMore = $('article#event .btn-more-shows');

        btnMore.on('click', function() {
            $('article#event .col-right .shows .row:hidden').each(function() {
                $(this).fadeIn();
            });

            btnMore.slideUp(500);
        });
    },

    /**
     * Redirect the user to the selected tour (place).
     */
    placeSelector: function() {
        $('article#event #place-selector').change(function() {
            window.location.href = $(this).val();
        });
    },

    /**
     * Attach/stick the aside (sidebar) to the page when the user scrolls such that it is always visible.
     */
    stickyAside: function() {
        var $widgets = $('article#event .col-right .widgets');
        var $content = $('article#event .col-content > .inner');
        var offsetAsideTop = $widgets.offset().top;
        var offsetAsideBottom = $widgets.offset().top + $widgets.outerHeight(true);
        var offsetContentBottom = $content.offset().top + $content.outerHeight(true);
        var widgetsWidth = $widgets.width();
        var widgetsHeight = $widgets.outerHeight(true);
        var lastY = $(window).scrollTop();

        var foo = false;
        var fooScrollTop = 0;
        var barScrollTop = 0;

        function setSticky() {
            // Determine current scroll direction
            var currY = $(window).scrollTop();
            var y = (currY > lastY) ? 'down' : ((currY === lastY) ? 'none' : 'up');

            // Determine scroll position
            var windowScroll = $(window).scrollTop();
            var windowOffsetBottom = windowScroll + $(window).height();

            if (widgetsHeight < $(window).height()) {
                // The sidebar if smaller than the window

                // 50: at this position the header animation is over (min-header size)
                // 15: margin
                if (currY > 50 && currY > (offsetAsideTop - $('#site-header nav').height() - 15)) {
                    // Set the aside stick to the top

                    if (barScrollTop == 0) {
                        barScrollTop = currY; // Initial position (top offset) of the div
                    }

                    $widgets.removeClass('sticky-bottom').addClass('sticky-top');
                    $widgets.attr('style', '').css({
                        'width': widgetsWidth,
                        'top': barScrollTop + 'px'
                    });

                    if ((offsetAsideBottom + currY - 100) > offsetContentBottom) {
                        // Bottom of the content reached
                        // Make sure the aside stop at the position of the left content area
                        var posA = $content.offset().top + $content.height();
                        var posB = currY + $(window).height();
                        var offsetBottom = Math.floor(posB - posA);

                        if (offsetBottom > 0) {
                            $widgets.removeClass('sticky-top').addClass('sticky-bottom');
                            $widgets.css({
                                'top': '',
                                'bottom': offsetBottom + 'px'
                            });
                        }
                    }
                } else {
                    // Reset to normal position
                    $widgets.attr('style', '').removeClass('sticky-bottom').removeClass('sticky-top');
                }

                return;
            } else {
                // The sidebar if bigger than the window

                $widgets.css('width', widgetsWidth);

                if (windowOffsetBottom > offsetAsideBottom) {
                    // Bottom of .widget reached

                    if (y == 'up') {
                        // Scroll position: up
                        // Set the aside stick to the top

                        var headerHeight = $('#site-header nav').height();
                        var topPosition = $widgets.height() - $(window).height();

                        $widgets.removeClass('sticky-bottom').addClass('sticky-top');

                        if (foo == false) {
                            $widgets.css('top', -topPosition + 'px');
                            foo = true;
                            fooScrollTop = currY;
                        } else {
                            var newPosition = topPosition - (parseInt(fooScrollTop) - parseInt(currY))

                            if (newPosition > -headerHeight) {
                                // Top of .widgets reached
                                $widgets.css('top', -newPosition + 'px');
                            }

                            fooScrollTop = currY;
                        }
                    } else if (y == 'down') {
                        // Scroll position: down
                        // Set the aside stick to the bottom

                        $widgets.removeClass('sticky-top').addClass('sticky-bottom');
                        $widgets.css('top', '');

                        foo = false;
                        fooScrollTop = 0;
                    } else if (y == 'none' && currY > 0) {
                        // Scroll position: none (static)
                        // On page load for example with the scroll position in the middle of the page
                        // Set the aside stick to the bottom

                        $widgets.removeClass('sticky-top').addClass('sticky-bottom');
                        $widgets.css('top', '');
                    }
                } else {
                    var reset = false;

                    if ($widgets.hasClass('sticky-top')) {
                        if (currY <= $('#site-header nav').height()) {
                            // Initial position reached
                            reset = true;
                        }
                    } else {
                        reset = true;
                    }

                    if (reset) {
                        $widgets.removeClass('sticky-top');
                        $widgets.removeClass('sticky-bottom');
                        $widgets.attr('style', '');
                        reset = false;
                    }
                }

                $widgets.css('width', widgetsWidth);

                if (windowOffsetBottom > offsetContentBottom) {
                    // Bottom of the content reached
                    // Make sure the aside stop at the position of the left content area
                    var posA = $content.offset().top + $content.height();
                    var posB = currY + $(window).height();
                    var offsetBottom = Math.floor(posB - posA);

                    if (offsetBottom > 0) {
                        $widgets.removeClass('sticky-top').addClass('sticky-bottom');
                        $widgets.css({
                            'top': '',
                            'bottom': offsetBottom + 'px'
                        });
                    }
                }
            }

            // Update last scroll position to current position
            lastY = currY;
        }

        $(window).on('scroll', setSticky);
        $(window).on('resize', setSticky);

        setSticky();
    },

    asideMobile: function() {
        var html = $('article#event .col-right').html();
        $('article#event .col-aside-mobile').html(html);
    },
};

module.exports = new FrontEventsSingle();
